import React, {useState} from "react";
import {SingleStar} from "@components/elements/SingleStar";

export function ClickableStarRating(props: { onChange: (e: number) => void, rating: number, maxRating: number, step: number, onReset: () => void }) {
    const [hoverRating, setHoverRating] = useState<number>(0);
    const [isHovering, setIsHovering] = useState<boolean>(false);

    return <span className="flex justify-start cursor-pointer"
                 tabIndex={0} aria-label="rating"
                 onKeyDown={(e) => {
                     if (e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'ArrowUp') {
                         const delta = e.key === 'ArrowLeft' || e.key === 'ArrowDown' ? -1 * props.step : props.step;
                         props.onChange(props.rating + delta);
                     }
                 }}
                 onMouseLeave={() => setIsHovering(false)}
                 onMouseMove={(e) => {
                     const rect = e.currentTarget.getBoundingClientRect();
                     const x = e.clientX - rect.left;
                     const width = rect.right - rect.left;
                     const rating = Math.ceil(x / width * props.maxRating / props.step) * props.step;
                     setIsHovering(true);
                     setHoverRating(rating);
                 }}
                 onClick={(e) => {
                     const rect = e.currentTarget.getBoundingClientRect();
                     const x = e.clientX - rect.left;
                     const width = rect.right - rect.left;
                     const rating = Math.ceil(x / width * props.maxRating / props.step) * props.step;
                     setIsHovering(false);
                     if (rating === props.rating) props.onReset(); else props.onChange(rating);
                 }}
                 title={props.rating.toString()}>
            {[...Array(props.maxRating)].map((_, i) => <SingleStar
                key={i}
                index={i}
                precision={props.step}
                isHovering={isHovering}
                hoverValue={hoverRating - i}
                percentage={Math.min(1, Math.max(0, props.rating - i)) * 100}
            />)}
                </span>
}